var SecureMessageView = require('./../secure-message/SecureMessageView');
var PaymentDetailsFormModel = require('./../payment/PaymentDetailsFormModel');
var applicationUtils = require('./../applicationUtils');
var dateUtils = require('./../utils/dateUtils');
var receiptSummaryItemTemplate = require('./receiptSummaryItemTemplate.hbs');

var PAYMENT_METHODS = PaymentDetailsFormModel.PAYMENT_METHODS;
var CARDS = PaymentDetailsFormModel.CARDS;

/**
 * @class ReceiptSummaryItemView (based on SecureMessageReceiptView)
 * @constructor
 * @param option {Object}
 *   @param options.model {Torso.Model}
 *   @param options.context.patientVecnaId {String}
 */
module.exports = SecureMessageView.extend({
  tagName: 'li',
  className: 'index__item index__item--receipt',
  /**
   * Adds attributes to the the top level element (this is to support existing behavioral tests that query these values).
   * This only works because, as an item view, this view will only be created when the model already exists.  Values will not
   * be updated dynamically if they change for this view after it renders.
   * @returns {{receipt-vecna-id: String}} the receipt's Vecna id.
   */
  attributes: function() {
    return {
      'data-receipt-vecna-id': this.model.get('vecnaId')
    };
  },

  template: receiptSummaryItemTemplate,

  /**
  * @method prepare
  * @override
  */
  prepare: function() {
    var templateContext = SecureMessageView.prototype.prepare.apply(this);
    templateContext.secureMessage.payment.CARDS = CARDS;
    templateContext.secureMessage.payment.PAYMENT_METHODS = PAYMENT_METHODS;
    templateContext.secureMessage.payment.currentApplication = applicationUtils.currentApplication;
    templateContext.secureMessage.payment.expirationYear = dateUtils.getExpirationYear(templateContext.secureMessage.payment.expirationDate);
    templateContext.secureMessage.payment.expirationMonth = dateUtils.getExpirationMonth(templateContext.secureMessage.payment.expirationDate);
    templateContext.secureMessage.payment.cardNumberLast4 = templateContext.secureMessage.payment.last4;
    return templateContext;
  }
});
